// Date/Time utils
// get system UTC offset
export function getTimezoneOffset() {
  return new Date().getTimezoneOffset();
};

// change UTC offset
export function changeUtcOffset(date: Date, offsetMinutes: number) {
  const initialTime = date.getTime();
  const offsetMilliseconds = offsetMinutes * 60 * 1000;
  const newTime = initialTime + offsetMilliseconds;
  return new Date(newTime);
};

// convert UTC offset minutes to the format of UTC+hh:mm or UTC-hh:mm
export function convertMinutes(minutes: number) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  const hourMinuteString = 'UTC' + formatHours(hours) + ':' + formatMinutes(remainingMinutes);

  return hourMinuteString;
};

// convert hours to the format of +hh or -hh
function formatHours(hours: number) {
  const numHours = Number(hours);

  if (isNaN(numHours)) {
    return "Invalid input";
  }

  const absHours = Math.abs(numHours);
  const sign = numHours < 0 ? "-" : "+";
  const formattedHours = absHours < 10 ? `0${absHours}` : `${absHours}`;

  return `${sign}${formattedHours}`;
};

// convert minutes to the format of mm
function formatMinutes(minutes: number) {
  return String(minutes).padStart(2, '0');
};

// convert UTC offset to minutes
export function changeUtcOffsetToMinutes(offset: string) {
  const sign = offset[0] === '-' ? -1 : 1;
  const [hours, minutes] = offset.slice(3).split(':').map(Number);
  return sign * (hours * 60 + minutes);
};
